import { belowDesktop, desktop, tablet } from 'config/breakpoints';

export default {
  belowDesktop: `@media ${belowDesktop}`,
  tablet: `@media ${tablet}`,
  desktop: `@media ${desktop}`,
};
